enum VpcDataSourceEnum {
	default = 'default',
	dexf = 'DEXF',
	iows = 'IOWS'
}

export default VpcDataSourceEnum;
